import PropTypes from "prop-types"
import { Flex } from "antd"
import { UserOutlined, FilePdfOutlined, RightOutlined } from "@ant-design/icons"
import TicketTypeIcon from "../BookingTable/TicketTypeIcon"
import BookingTag from "../BookingTag"
import PaymentTag from "../PaymentTag"
import styles from "./ReservationCard.module.css"

// Mobile card for a Reservation row. Tapping the card opens the reservation detail.
const ReservationCard = ({ item, onView }) => (
  <button type="button" className={styles.card} onClick={() => onView(item)}>
    <Flex align="center" gap={8} className={styles.idRow}>
      <TicketTypeIcon isGroup={item.experienceIsGroup} />
      <span className={styles.bookingId}>{item.bookingId}</span>
      <span className={styles.dateTime}>
        {[item.experienceDate, item.experienceTime].filter(Boolean).join(" · ")}
      </span>
      <RightOutlined className={styles.chevron} />
    </Flex>

    <span className={styles.clientName}>{item.name}</span>
    {item.experience && <span className={styles.experience} title={item.experience}>{item.experience}</span>}

    <Flex align="center" gap={8} wrap="wrap" className={styles.meta}>
      <Flex align="center" gap={4}>
        <UserOutlined className={styles.metaIcon} />
        <span className={styles.guestCount}>{item.guestCount}</span>
      </Flex>
      {item.paymentTag && <PaymentTag label={item.paymentTag.label} color={item.paymentTag.color} />}
      {item.collectionTag && <PaymentTag label={item.collectionTag.label} color={item.collectionTag.color} />}
      <BookingTag color={item.docsSign >= item.docsTotal ? "success" : "error"} className={styles.docsTag}>
        <Flex align="center" gap={4}>
          <FilePdfOutlined />
          {item.docsSign}/{item.docsTotal}
        </Flex>
      </BookingTag>
    </Flex>
  </button>
)

ReservationCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    bookingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    experience: PropTypes.string,
    experienceDate: PropTypes.string,
    experienceTime: PropTypes.string,
    experienceIsGroup: PropTypes.bool,
    guestCount: PropTypes.number,
    paymentTag: PropTypes.shape({ label: PropTypes.string, color: PropTypes.string }),
    collectionTag: PropTypes.shape({ label: PropTypes.string, color: PropTypes.string }),
    docsSign: PropTypes.number,
    docsTotal: PropTypes.number
  }).isRequired,
  onView: PropTypes.func.isRequired
}

export default ReservationCard
